import { render, staticRenderFns } from "./IbxModal.vue?vue&type=template&id=5bf2d1f0"
import script from "./IbxModal.vue?vue&type=script&lang=js"
export * from "./IbxModal.vue?vue&type=script&lang=js"
import style0 from "./IbxModal.vue?vue&type=style&index=0&id=5bf2d1f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports